<template>
  <div class="emailfind">
    <el-form
      :model="ruleForms"
      ref="ruleForms"
      :rules="rules"
      label-width="150px"
      class="demo-ruleForm"
      v-show="emailfirstStap"
    >
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('forgectEmail.email')"
            prop="emails"
          >
            <el-input
              v-model="ruleForms.emails"
              class="inputsty"
              :placeholder="$t('forgectEmail.emailplace')"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="content posit">
        <div class="formLeft">
          <drag-verify
            :width="316"
            :height="40"
            handlerIcon="el-icon-d-arrow-right"
            successIcon="el-icon-check"
            :text="$t('forgectEmail.drag')"
            :success-text="$t('forgectEmail.check')"
            background="#ddd"
            progress-bar-bg="#2ACBF8"
            text-size="14px"
            :circle="true"
            ref="Verify"
          >
          </drag-verify>
        </div>
      </div>
    </el-form>
    <el-form
      :model="ruleFormsnext"
      ref="ruleFormsnext"
      :rules="rulesnext"
      :label-width="this.$i18n.locale=='en'?'250px':'150px'"
      class="demo-ruleForm"
      v-show="!emailfirstStap"
    >
      <div>
        {{$t('forgectEmail.text')}}
        <span>{{ email.replace(/(.{1}).+(.{2}@.+)/g, "$1****$2") }}</span>
      </div>
      <br />
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('forgectEmail.emailcode')"
            prop="code"
          >
            <el-input
              v-model="ruleFormsnext.code"
              class="picwid"
              :placeholder="$t('forgectEmail.emailtext')"
            ></el-input>
            <div class="codewid">
              <el-button
                type="success"
                @click="phonesendCodes"
              >{{
                codeStrs
                }}</el-button>
            </div>
          </el-form-item>
        </div>
      </div>
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('forgectEmail.passwords')"
            prop="passwords"
          >
            <el-input
              v-model="ruleFormsnext.passwords"
              class="inputsty"
              type="password"
              :placeholder="$t('forgectEmail.passwordText')"
              v-popover:popovers
            ></el-input>
            <el-popover
              ref="popovers"
              placement="right"
              width="30"
              trigger="focus"
              content=""
            >
              <p v-for="(item,index) in $t('forgectEmail.popovers')" :key="index">
              {{item.name}}
            </p>
            </el-popover>
          </el-form-item>
        </div>
      </div>
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('forgectEmail.rePasswords')"
            prop="rePasswords"
          >
            <el-input
              v-model="ruleFormsnext.rePasswords"
              class="inputsty"
              type="password"
              :placeholder="$t('forgectEmail.rePasswordsText')"
              v-popover:popoversr
            ></el-input>
            <el-popover
              ref="popoversr"
              placement="right"
              width="30"
              trigger="focus"
              content=""
            >
              <p>{{$t('forgectEmail.popoversr')}}</p>
            </el-popover>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="elbtn">
      <el-button
        @click="nextTap('ruleForms')"
        class="rightBtn"
        type="success"
        style="margin-top:70px;"
        size="medium"
        v-if="emailfirstStap"
      >{{$t('forgectEmail.next')}}</el-button>
      <el-button
        @click="submits('ruleFormsnext')"
        class="rightBtn"
        type="success"
        size="medium"
        v-else
      >{{$t('forgectEmail.define')}}</el-button>
    </div>
    <!-- 点击下一步提示弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      center
    >
      <img
        style="width:60px;height:60px;"
        src="../../assets/img/right.png"
        alt=""
      />
      <div>{{$t('forgectEmail.nonebind')}}</div>
    </el-dialog>
    <!-- 修改成功弹窗 -->
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <img
        style="width:60px;height:60px;"
        src="../../assets/img/right.png"
        alt=""
      />
      <div style="margin-top:10px;">{{$t('forgectEmail.passwordsuccess')}}</div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="medium"
          type="success"
          @click="backlogin"
        >{{$t('forgectEmail.back')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dragVerify from "vue-drag-verify";
export default {
  components: {
    dragVerify
  },
  data() {
    var loginPass = (rule, value, callback) => {
      var rest = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,}$/;
      if (
        !rest.test(value) ||
        !value ||
        value.length < 6 ||
        value.length > 20
      ) {
        return callback(new Error(this.$t('checkvalid.password')));
      } else {
        callback();
      }
    };
    var emailvalids = (rule, value, callback) => {
      var rests = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (!rests.test(value) || value == 0) {
        return callback(new Error(this.$t('checkvalid.email')));
      } else {
        callback();
      }
    };
    var rePass = (rule, value, callback) => {
      var rest = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,}$/;
      if (
        !rest.test(value) ||
        !value ||
        value.length < 6 ||
        value.length > 20
      ) {
        return callback(new Error(this.$t('checkvalid.password')));
      } else if (value !== this.ruleFormsnext.passwords) {
        callback(new Error(this.$t('checkvalid.same')));
      } else {
        callback();
      }
    };
    return {
      ruleForms: {
        emails: ""
      },
      rules: {
        emails: [{ required: true, validator: emailvalids, trigger: "blur" }]
      },
      ruleFormsnext: {
        passwords: "",
        rePasswords: "",
        code: ""
      },
      rulesnext: {
        code: [{ required: true, message: this.$t('checkvalid.code'), trigger: "blur" }],
        rePasswords: [{ required: true, validator: rePass, trigger: "blur" }],
        passwords: [{ required: true, validator: loginPass, trigger: "blur" }]
      },
      codeStrs: this.$t('forgectPhone.codeStr'),
      emailfirstStap: true,
      btnemailTitle: "下一步",
      dialogVisible: false,
      centerDialogVisible: false,
      email: ""
    };
  },
  created() {
    this.emailfirstStap = true;
  },
  methods: {
    nextTap() {
      this.$refs.ruleForms.validate(valid => {
        if (valid) {
          if (!this.$refs.Verify.isPassing) {
            this.$message({
              message: this.$t('checkvalid.hd'),
              type: "warning"
            });
            return false;
          } else {
            this.emailfirstStap = false;
            this.email = this.ruleForms.emails;
          }
        } else {
          console.log("error submit!!");
          return;
        }
      });
    },
    submits() {
      this.$refs.ruleFormsnext.validate(valid => {
        if (valid) {
          const data = {
            password: this.ruleFormsnext.passwords,
            email: this.email,
            code: this.ruleFormsnext.code
          };
          this.$http
            .post("/login/email_find_pass", data)
            .then(res => {
              console.log(res);
              if (res.status == 200) {
                if (res.data.status == 0) {
                  this.centerDialogVisible = true;
                } else {
                  this.$message({
                    message: res.data.error,
                    type: "warning",
                    duration: 1500
                  });
                  return;
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return;
        }
      });
    },
    // 注册成功后登录
    backlogin() {
      this.centerDialogVisible = false;
      this.$router.push({
        name: "login"
      });
    },
    phonesendCodes() {
      let that = this;
      let times = 60;
      // this.codeBinds();
      const data = {
        email: this.email
      };
      this.$http
        .post("/common/get_email_code", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t('checkvalid.codesuccess'),
                type: "success",
                duration: 1500
              });
              let timer = setInterval(() => {
                --times;
                that.codeStrs = times + "S";
                if (times == 0) {
                  this.codeStrs = this.$t('forgectPhone.codeStr');
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    codeBinds() {
      const data = {
        email: this.email
      };
      this.$http
        .post("/common/get_email_code", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t('checkvalid.codesuccess'),
                type: "success",
                duration: 1500
              });
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss">
.emailfind {
  .codewid {
    margin-left: 25px;
  }
  .drag_verify {
    margin-bottom: 20px !important;
  }
}
</style>
